require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./responsive-web-design-basic-css-use-css-variables-to-change-several-elements-at-once.json") })
        }
      }, "path---responsive-web-design-basic-css-use-css-variables-to-change-several-elements-at-once");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---responsive-web-design-basic-css-use-css-variables-to-change-several-elements-at-once!./.cache/json/responsive-web-design-basic-css-use-css-variables-to-change-several-elements-at-once.json
// module id = 2616
// module chunks = 231608221292675